class CmsBlock {
  id;
  componentName;
  isContainer;
  slots;
  placeholders;
  props;
  constructor(data) {
    this.id = data.id;
    this.componentName = data.blockName;
    this.isContainer = data.isContainer;
    this.slots = data.placeholders ? Object.keys(data.placeholders) : [];
    this.placeholders = data.placeholders;
    this.props = {
      values: data.values,
      cfgs: data.cfgs,
      extras: data.extras
    };
  }
}
export const extractBlocks = (blocks) => blocks.map((b) => new CmsBlock(b));
export const extractLayout = (contentData) => {
  const layout = {
    componentName: null,
    props: []
  };
  if (contentData.layout) {
    layout.componentName = `Layout${contentData.layout.id}`;
    layout.props = contentData.placeholders.content;
  }
  return layout;
};
